import { createStandardAction } from 'typesafe-actions';
import { IBusinessInfo } from './types';

const setBusinessInfo =
  createStandardAction('BUSINESS_INFO/SET')<Partial<IBusinessInfo>>();

export { setBusinessInfo };
